define('SC.SummitThemeExtension.ItemRelations.SC.Configuration', [
  'SC.SummitThemeExtension.Common.Configuration'
], function ThemeExtensionItemRelations(Configuration) {
  'use strict';

  return {
    loadModule: function loadModule() {
      var overallConfiguration = Configuration.getOverallConfiguration();
      if (
        overallConfiguration.bxSliderDefaults &&
        overallConfiguration.bxSliderDefaults.slideWidth
      ) {
        overallConfiguration.bxSliderDefaults.slideWidth = 272;
        overallConfiguration.bxSliderDefaults.maxSlides = 4;
      }
    }
  };
});
